import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
export const routers = [
  {
    name: "Highest scores",
    path: "/voting/departments",
    to: "/voting/departments/highest-scores",
    permissions: [],
  },
  {
    name: "Group scores",
    path: "/voting/departments",
    to: "/voting/departments/group-scores",
    permissions: [],
  },
];

const DepartmentLeftSide = () => {
  const location = useLocation();
  const { hasPermissions } = useRequiredAuth();
  return (
    <>
      <div className="list-group mt-4 ml-3">
        {routers.map((router, index) => (
          <React.Fragment key={index + 1}>
            {/* {hasPermissions(router.permissions) && ( */}
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                to={router.to}
                className={`list-group-item list-group-item-action  ${
                  location.pathname.includes(router.to)
                    ? "active"
                    : "text-dark "
                }`}
              >
                <span className="text-truncate  menu-item">{router.name}</span>
              </Link>
            {/* )} */}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default DepartmentLeftSide;
